import React, {useContext} from 'react';
import './ErrorCard.less';
import {getSafeTranslation} from "helpers/localization.helper";
import {TranslationsContext} from "contexts/translations-context";
import InfoIcon from 'new-images/info.svg';

export const ErrorCard = ({errorKey}) => {
	const translations = useContext(TranslationsContext);
	return <div className="error-card">
		<span className="error-card__icon" dangerouslySetInnerHTML={{__html: InfoIcon}}></span>
		{getSafeTranslation(errorKey, translations)}
	</div>
}
